export default __webpack_public_path__ + "static/Metallica-Logo-c61371f3ff90b33f257322ffa7d88bb6.png";